import { useNavigate } from "react-router";
import { gql, useApolloClient } from "@apollo/client";
import { useEffect, useState } from "react";

const GET_DATA_PAGINATED = gql`
  query GetMicronarrativas($after: String, $first: Int = 100, $order: OrderEnum = ASC) {
    micronarrativas(first: $first, after: $after, where: { orderby: { field: DATE, order: $order } }) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          title
          micronarrativasMeta {
            tags_micro {
              edges {
                node {
                  id
                  name
                }
              }
            }
          }
        }
      }
    }
  }
`;

export function useTags() {
  const client = useApolloClient();
  const [state, setState] = useState({
    loading: true,
    error: null,
    data: [],
    counts: {},
  });

  useEffect(() => {
    let cancelled = false;

    async function fetchAllTags() {
      let after = null;
      const allEdges = [];

      try {
        do {
          const { data } = await client.query({
            query: GET_DATA_PAGINATED,
            variables: { after, first: 100, order: "ASC" },
            fetchPolicy: "network-only",
          });

          const conn = data?.micronarrativas;
          if (!conn) break;

          allEdges.push(...(conn.edges || []));
          after = conn.pageInfo?.endCursor || null;

          if (!conn.pageInfo?.hasNextPage) break;
        } while (true);

        if (cancelled) return;

        console.log(`Finished fetching all entries: ${allEdges.length} total`);

        const allTags =
          allEdges.flatMap(
            (edge) =>
              edge.node.micronarrativasMeta?.tags_micro?.edges?.map(
                (tagEdge) => tagEdge.node
              ) || []
          ) || [];

        const uniqueTagNames = [
          ...new Set(allTags.map((tag) => tag.name)),
        ].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));

        const counts = allTags.reduce((acc, tag) => {
          acc[tag.name] = (acc[tag.name] || 0) + 1;
          return acc;
        }, {});

        setState({
          loading: false,
          error: null,
          data: uniqueTagNames,
          counts,
        });
      } catch (error) {
        if (cancelled) return;
        setState({ loading: false, error, data: [], counts: {} });
      }
    }

    fetchAllTags();
    return () => {
      cancelled = true;
    };
  }, [client]);

  return state;
}

export default function HomeTag(){
    const { loading, error, data:tags, counts } = useTags();
    const navigate = useNavigate();

    const handleTagClick = (tag) => {
      navigate(`/tags/${tag}`);
    };

    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error.message}</p>;

    if (!tags.length) return <p>No data found.</p>;


    return(
        <div className="group-tags">
            {
              tags.map((tag, id) => (
                  <div
                      key={id}
                      className='home-tag'
                      onClick={() => handleTagClick(tag)}
                      style={{ cursor: 'pointer' }}
                  >
                    <div className="description">{tag}</div>
                    <span className="counts">{counts[tag]}</span>
                  </div>
                ))
            }
        </div>
    )
}